import { Download, RunningWithErrors, SummarizeOutlined } from "@mui/icons-material";
import { useMemo } from "react";
import useTrees from "../../../../Hooks/useTrees";
import useUIBp from "../../../../Hooks/useUIBoilerplate";
import { useWorker } from "../../../../Hooks/useWorker";
import { devicesDataId } from "../../../../store/actions/devices/getAllDevices";
import { UIactions } from "../../../../store/slices/UI";
import { groupsTreeId } from "../../../GroupsTraveler/Actions/loadGroupsTree";
import MoreActions2 from "../../../UI/BasicLayout/Components/MoreActions/MoreActions2";
import generateC365ScanReport from "../../Actions/c365ScanErrors";
import exportReport from "../../Actions/exportReport";
import { forceRescanId } from "../../Actions/forceRescan";
import { c365devicesListDataId } from "../../Actions/getc365List";

const UIText = {
  "es-CL": { label: "Exportar" },
  "en-US": { label: "Export" },
};

const Export = () => {
  const { auth, dispatch, UI, warehouse, settings } = useUIBp();
  const { M365server, cloner_key } = auth;
  const trees = useTrees() ?? {};
  const groups = trees[groupsTreeId] ?? [];
  const locale = settings.locale;
  const { working } = useWorker(forceRescanId);
  const selected = useMemo(() => UI.selected ?? [], [UI.selected]);
  const c365Devices = useMemo(() => {
    let out = [];
    for (const key in warehouse[c365devicesListDataId]) {
      out.push(warehouse[c365devicesListDataId][key]);
    }
    return out;
  }, [warehouse]);
  const devicesObjs = useMemo(() => warehouse[devicesDataId] ?? {}, [warehouse]);

  const { onlySelected, onlySelectedC365 } = useMemo(() => {
    let devices = [];
    for (const key in devicesObjs) {
      devices.push(devicesObjs[key]);
    }
    let onlySelected = [];
    for (const mid of selected) {
      const dev = devices.find((x) => x.mid === mid);
      onlySelected.push(dev);
    }

    let onlySelectedC365 = [];
    for (const mid of selected) {
      for (const mid2 of c365Devices) {
        if (mid === mid2) {
          const dev = devices.find((x) => x.mid === mid);
          onlySelectedC365.push(dev);
        }
      }
    }
    return { onlySelected, onlySelectedC365 };
  }, [selected, c365Devices, devicesObjs]);

  const handleReportExport = () => {
    let devices = [];
    for (const key in devicesObjs) {
      devices.push(devicesObjs[key]);
    }
    let onlySelected = [];
    for (const mid of selected) {
      const dev = devices.find((x) => x.mid === mid);
      onlySelected.push(dev);
    }
    dispatch(exportReport({ devices, onlySelected, groups, locale: settings.locale }));
  };

  const handleC365ScanReport = () => {
    if (onlySelectedC365.length === onlySelected.length) {
      const scans = onlySelectedC365.map((item) => {
        return {
          user: item.user,
          device: item.mid,
        };
      });
      dispatch(
        generateC365ScanReport({
          M365server,
          cloner_key,
          scans,
          locale,
        }),
      );
    } else {
      dispatch(
        UIactions.openModal2({
          type: "mixedC365ReportWarning-confirmation",
          payload: {
            selected: onlySelected,
            scans: onlySelectedC365,
          },
        }),
      );
    }
  };

  const buttonsData = [
    {
      icon: <SummarizeOutlined sx={{ color: "grey" }} />,
      UIText: {
        "es-CL": { label: "Reporte" },
        "en-US": { label: "Report" },
      },
      onClick: handleReportExport,
    },
    {
      icon: <RunningWithErrors sx={{ color: "grey" }} />,
      UIText: {
        "es-CL": { label: "Escaneo Cloner365" },
        "en-US": { label: "Cloner365 scan" },
      },
      disabled: onlySelectedC365.length === 0,
      onClick: handleC365ScanReport,
    },
  ];

  return (
    <MoreActions2
      {...{
        id: "userCreation",
        buttonsData,
        UIText,
        icon: <Download sx={{ fontSize: 18 }} />,
        placement: "bottom-start",
        disabled: working,
      }}
    />
  );
};

export default Export;
